<script>
import ElTableColumn from 'element-ui/lib/table-column'

export default {
  // 直接继承列定义，保留 owner、columnId、嵌套表头及 scoped slot 协议。
  name: 'ElTableColumn',
  extends: ElTableColumn
}
</script>
